import request from '@/utils/request'

export function communityOverview (query) {
  return request({
    url: '/statistics/community/overview',
    method: 'get',
    params: query
  })
}